import {Injectable} from '@angular/core';
import Bugsnag from "@bugsnag/js";
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {BehaviorSubject} from 'rxjs';

export interface IValidationResponse {
  isValid: boolean;
  explication?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ValidateCommentsAIService {

  BASE_URL = environment.apiUrl
  
  // Track l'état de validation IA pour chaque question
  questionAIValidationStatus$ = new BehaviorSubject<Record<string, boolean>>({});

  constructor(
    private http: HttpClient,
  ) {
  }

  validateAnswerWithOpenAI(question: string, answer: string, lang: string, selectedStatement?: string): Promise<IValidationResponse> {
    return new Promise((resolve, reject) => {
      if (!question || !answer) {
        return resolve({isValid: true});
      }
      this.http.post(`${this.BASE_URL}/appCommunity/publicActions`,
        {action: 'validateWithAI', params: {question, answer, lang, selectedStatement}})
        .subscribe({
          next: (response: any) => {
            resolve(JSON.parse(response.data.datas.choices[0].message.content));
          },
          error: err => {

            console.error('[Validation] AIValidation Error', err);
            Bugsnag.notify(err, (event) => {
              event.addMetadata('ValidateCommentsAIService', {
                method: 'createConnectionToOpenAI',
                body: {action: 'validateWithAI', params: {question, answer}},
                endpoint: `${this.BASE_URL}/appCommunity/publicActions`
              })
            })

          },
          complete: () => {
          }
        })
    })
  }

  updateQuestionAIValidationStatus(questionKey: string, isValid: boolean) {
    const currentStatus = this.questionAIValidationStatus$.value;
    this.questionAIValidationStatus$.next({
      ...currentStatus,
      [questionKey]: isValid
    });
  }

  getQuestionAIValidationStatus(questionKey: string): boolean {
    return this.questionAIValidationStatus$.value[questionKey] !== false;
  }


}
